import AuthFlowFrame from "../../components/AuthFlowFrame";
import { Content } from "@jobber/components/Content";
import { Text } from "@jobber/components/Text";
import { Link } from "@jobber/components/Link";
import { useEffect, useState } from "react";
import { xeroRedirectUrl} from "../../services";
import { AuthFlowButton } from "../../types";
import {showError} from "../../helpers";

function Step1() {
    const [buttonLink, setButtonLink] = useState("");
    useEffect(() => {
        (async () => {
            try {
                const state = sessionStorage.getItem('state');
                const {data: buttonLink} = await xeroRedirectUrl(state);
                setButtonLink(buttonLink.redirect_url);
            } catch(e: any) {
                showError("Error establishing connection with Xero: " + e.message);
            }
        })();
    }, []);

    const button: AuthFlowButton = {
        link: buttonLink,
        text: "Connect to Xero",
        type: "primary",
        disabled: false,
        loading: false,
    }

    return (
        <AuthFlowFrame
            pretitle={"Let's get you set up"}
            title={"Connect to Xero"}
            step={1}
            totalSteps={3}
            button={button}
        >
            <Content type={"div"} spacing={"base"}>
                <Text size={"large"}>
                    After connecting your Xero account, your integration will be ready to go!
                </Text>
                <Text size={"base"} variation={"subdued"}>
                    If you don’t have a Xero account, <Link url={"https://xero5440.partnerlinks.io/jobber"} external={true}>create
                    a Xero account</Link> and then come back to this tab to finish setting up your integration.
                </Text>
            </Content>
        </AuthFlowFrame>
    );
}

export default Step1;
